import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { AuthProvider } from "./context/AuthProvider";
import "./i18n";
import LocaleProvider from "./i18n/LocaleProvider";

// The data router (createBrowserRouter) is created inside App so that the
// AuthProvider is available to route elements and the navigation blocker
// (unsaved-changes guard) can use useBlocker.
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <LocaleProvider>
      <AuthProvider>
        <App />
      </AuthProvider>
    </LocaleProvider>
  </React.StrictMode>,
);
